import titleLogoImg from "@/assets/images/user/titleLogoImg.svg";

export default function SubTitle({ title, className }: { title: string; className?: string }) {
    return (
        <div className={`flex items-center gap-[12px] md:gap-[16px] ${className}`}>
            <img src={titleLogoImg} alt="GXG" className="size-[24px] md:size-[auto]" />
            <p className="text-[22px] font-['GongGothicBold'] text-black md:text-[40px]">{title}</p>
        </div>
    );
}
